import React, { useEffect, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import axios from 'axios';
import { MonoLabel } from '../components/Editorial';

export default function VerifyEmailPage() {
  const [searchParams] = useSearchParams();
  const [status, setStatus] = useState('verifying'); // 'verifying' | 'success' | 'already' | 'error'
  const [errorMessage, setErrorMessage] = useState('');

  useEffect(() => {
    const token = searchParams.get('token');
    if (!token) {
      setStatus('error');
      setErrorMessage('Verification link is missing its token.');
      return;
    }

    axios.post('/api/auth/verify-email', { token })
      .then((res) => {
        setStatus(res.data?.already_verified ? 'already' : 'success');
      })
      .catch((err) => {
        setStatus('error');
        setErrorMessage(err.response?.data?.detail || 'This verification link is invalid or has expired.');
      });
  }, [searchParams]);

  return (
    <div className="ed-auth">
      <div className="ed-auth__hero">
        <div>
          <MonoLabel onDark>EMAIL VERIFICATION</MonoLabel>
          <h1 className="ed-auth__hero-headline" style={{ marginTop: 16 }}>
            One last<br /><em>confirmation.</em>
          </h1>
        </div>
      </div>
      <div className="ed-auth__form-wrap">
        <div className="ed-auth__form">
        <div className="auth-logo" style={{ marginBottom: 24 }}>
          <img src="/logo-wordmark.png" alt="ProZpects" style={{ maxHeight: 36 }} />
        </div>

        <MonoLabel>VERIFY EMAIL</MonoLabel>
        <h2 style={{ fontFamily: 'var(--ed-font-serif)', fontSize: 36, fontWeight: 400, letterSpacing: '-0.015em', margin: '8px 0 24px' }}>
          Email check.
        </h2>

        {status === 'verifying' && (
          <div className="auth-subtitle">Verifying your email address…</div>
        )}

        {status === 'success' && (
          <div className="auth-success" role="alert">
            Your email address has been verified. Thanks for confirming!
          </div>
        )}

        {status === 'already' && (
          <div className="auth-success" role="alert">
            This email is already verified. You're all set.
          </div>
        )}

        {status === 'error' && (
          <div className="auth-error" role="alert">
            {errorMessage}
          </div>
        )}

        <div className="auth-footer" style={{ marginTop: 24 }}>
          <Link to="/dashboard">Go to dashboard</Link>
          {status === 'error' && (
            <>
              {' · '}
              <Link to="/login">Log in to resend</Link>
            </>
          )}
        </div>
        </div>
      </div>
    </div>
  );
}
